import React, { Component } from 'react';
import { slideLength, imageLocation } from '../config/constants';
import '../style/home.css';

export class Home extends Component {
	state = {};

	componentWillMount() {
		document.title = 'E Cobb Architects';
		this.images = this.props.data.images;
		let number = Math.floor(Math.random() * this.images.length);
		this.state.url1 = number;
		this.state.url2 = number + 1;
		this.state.fade = 'in';
		setTimeout(() => this.startSlides(), slideLength);
	}

	startSlides() {
		if (this.state.fade === 'in') {
			this.setState({ fade: 'out' });
			setTimeout(() => this.setState({ url1: (this.state.url1 + 2) % this.images.length }), 1000);
		} else {
			this.setState({ fade: 'in' });
			setTimeout(() => this.setState({ url2: (this.state.url2 + 2) % this.images.length }), 1000);
		}
		setTimeout(() => this.startSlides(), slideLength);
	}

	render() {
		return (
			<div className="Home" scroll="no">
				{/* <video
					autoPlay
					muted
					loop
					style={{
						position: 'fixed',
						right: '0',
						bottom: '0',
						minWidth: '100%',
						minHeight: '100%',
						zIndex: '-1'
					}}
				>
					<source src="vid.mp4" type="video/mp4" />
				</video> */}
				<div
					className={'background ' + '1'}
					style={{
						backgroundImage: `url(${imageLocation}home/${this.images[this.state.url1]})`
					}}
				/>
				<div
					className={'background ' + this.state.fade + '2'}
					style={{
						backgroundImage: `url(${imageLocation}home/${this.images[this.state.url2]})`
					}}
				/>
				<div className="media">
					<a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/ECobbArchitects/">
						<img
							style={{ height: '2.25em', width: '2.25em', marginRight: '1em', marginLeft: '1em' }}
							src="icons/facebook.svg"
							alt="fb"
						/>
					</a>
					<a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/ecobbarch/">
						<img style={{ height: '2.25em', width: '2.25em' }} src="icons/instagram.svg" alt="instagram" />
					</a>
				</div>
			</div>
		);
	}
}

export class MobileHome extends Home {
	render() {
		return (
			<div className="Home" scroll="no">
				<div
					className={'background ' + this.state.fade + '1'}
					style={{
						backgroundPosition: 'left',
						backgroundImage: `url(${imageLocation}home/${this.images[this.state.url1]})`
					}}
				/>
				<div
					className={'background ' + this.state.fade + '2'}
					style={{
						backgroundPosition: 'left',
						backgroundImage: `url(${imageLocation}home/${this.images[this.state.url2]})`
					}}
				/>
				<div className="media">
					<a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/ECobbArchitects/">
						<img
							style={{ height: '2.25em', width: '2.25em', marginRight: '1em', marginLeft: '1em' }}
							src="icons/facebook.svg"
							alt="fb"
						/>
					</a>
					<a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/ecobbarch/">
						<img style={{ height: '2.25em', width: '2.25em' }} src="icons/instagram.svg" alt="instagram" />
					</a>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/home.js